import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigurationSelectionDTO } from '../dto/response-dto/configuration-selection-response-dto';
import { ContractDetailsResponseDTO } from '../dto/response-dto/contract-details-response-dto';
import { PostContractRequestDTO } from '../dto/request-dto/post-contract-request-dto';

@Injectable({
    providedIn: 'root'
})
export class EditContractService {
    public constructor(private http: HttpClient) { }

    public getConfigurationSelectionContract(): Observable<ConfigurationSelectionDTO> {
        return this.http.get<ConfigurationSelectionDTO>(environment.baseUrl + 'Configuration/selection/contract?isNew=false');
    }

    public getContractDetails(pac: string, contractId: number, manufacturerName: string): Observable<ContractDetailsResponseDTO> {
        return this.http.get<ContractDetailsResponseDTO>(environment.baseUrl + `Contract/${pac}?contractId=${contractId}&manufacturerName=${manufacturerName}`);
    }

    public updateContractDetails(
        data: PostContractRequestDTO
    ): Observable<ContractDetailsResponseDTO> {
        return this.http.put<ContractDetailsResponseDTO>(environment.baseUrl + 'Contract', data);
    }
}
